<eca-monotron></eca-monotron>
<eca-monotron-body>
  <h1 class="eca-skip-link-focus-target" tabindex="-1">Local Scanning</h1>
  <eca-nav></eca-nav>
  <div class="eca-monotron-description-wrapper">
    <div class="eca-monotron-description">
      Please ensure your scanner is powered on and connected in order to begin the scanning process.
    </div>
  </div>

  <eca-web-scanner></eca-web-scanner>
</eca-monotron-body>
